import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="mt-24 border-t border-border/60 bg-sand">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/providence-partners-logo.png"
                alt="Providence Partners"
                className="h-12 w-12 rounded-full object-cover ring-1 ring-emerald/20"
              />
              <div className="leading-tight">
                <span className="block font-serif text-lg text-forest">Providence Partners</span>
                <span className="block text-[11px] uppercase tracking-[0.14em] text-gold">
                  Adult Day Care & Memory Care Locator
                </span>
              </div>
            </div>
            <p className="mt-4 max-w-xs text-sm italic text-muted-foreground">
              Timely Preparation for Future Eventualities.
            </p>
            <p className="mt-3 max-w-xs text-sm text-muted-foreground">
              A members-only directory built for working caregivers searching for trusted adult day,
              drop-in, and respite care.
            </p>
          </div>
          <div>
            <h4 className="font-serif text-base text-forest">Families seeking care</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li><Link to="/search" className="hover:text-foreground">Find a center</Link></li>
              <li><Link to="/register" className="hover:text-foreground">Create caregiver account</Link></li>
              <li><Link to="/dashboard/caregiver" className="hover:text-foreground">Manage inquiries</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-serif text-base text-forest">For Member Homes</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li><Link to="/for-facilities" className="hover:text-foreground">Become a member</Link></li>
              <li><Link to="/dashboard/facility" className="hover:text-foreground">Manage your profile</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-serif text-base text-forest">Try Before You Commit</h4>
            <p className="mt-3 text-sm text-muted-foreground">
              Emergency drop-in, weekly respite, and trial visits — to find the right fit before a
              long-term senior placement decision.
            </p>
            <a
              href="https://stressfreeaging.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-stressfreeaging-link"
              className="mt-4 inline-flex items-center gap-1.5 rounded-full border border-emerald/40 bg-emerald/5 px-3 py-1.5 text-xs font-medium text-emerald transition hover:bg-emerald/10"
            >
              <span aria-hidden>↗</span> Stress Free Aging — enrichment programs
            </a>
          </div>
        </div>
        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-border/60 pt-6 text-xs text-muted-foreground sm:flex-row">
          <span>© {new Date().getFullYear()} Providence Partners</span>
          <a href="tel:+15863068449" className="inline-flex flex-col items-center gap-0.5 font-medium text-forest hover:text-primary sm:items-end" data-testid="footer-phone-link">
            <span>Call us: (586) 306-8449</span>
            <span className="text-[10px] font-normal italic text-muted-foreground">Always available — 24/7</span>
          </a>
        </div>
      </div>
    </footer>
  );
}
